import React, { useMemo, cloneElement, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UniqueIdContainer from "../../components/modules/UniqueIdContainer";
import SignUpDetailsContainer from "../../components/modules/SignUpDetailsContainer";
import SubmitUniqueId from "./SubmitUniqueId";
import ProvideDetails from "./ProvideDetails";
import PhoneVerification from "./PhoneVerification";
import DiabetesTypeSelection from "./DiabetesTypeSelection";
import ChangeTemporaryPassword from "../../../../Diathrive/src/containers/ChangeTemporaryPassword";

export const StepComponent = ({
  navigation,
  currentStep,
  moveToNextStep,
  testIdScreen,
  authCredentials,
  setAuthCredentials,
  isSourceApp,
}) => {
  if (currentStep === 1) {
    return (
      <UniqueIdContainer testIdScreenName={testIdScreen}>
        <SubmitUniqueId
          navigation={navigation}
          moveToNextStep={moveToNextStep}
        />
      </UniqueIdContainer>
    );
  } else {
    let comp;
    switch (currentStep) {
      case 2:
        comp = <ProvideDetails />;
        break;
      case 3:
        comp = <PhoneVerification />;
        break;
      case 4:
        comp = <ChangeTemporaryPassword />;
        break;
      case 5:
        comp = <DiabetesTypeSelection />;
        break;
      default:
        comp = <ProvideDetails />;
        break;
    }
    const currentStepComponent = cloneElement(comp, {
      navigation,
      moveToNextStep,
      authCredentials,
      setAuthCredentials,
      isSourceApp,
    });

    return (
      <SignUpDetailsContainer testIdScreenName={testIdScreen}>
        {currentStepComponent}
      </SignUpDetailsContainer>
    );
  }
};

const SignUp = (props) => {
  const location = useLocation();
  const [step, setStep] = useState(location?.state?.step || 1);
  const [authCredentials, setAuthCredentials] = useState(
    location?.state?.authCredentials || {}
  );

  const isSourceApp = useMemo(() => {
    return location?.state?.hasOwnProperty("isSourceApp")
      ? location?.state?.isSourceApp
      : true;
  }, [location?.state]);

  const navigate = useNavigate();

  const testIdScreen = useMemo(() => {
    let id;
    switch (step) {
      case 1:
        id = "SubmitUniqueId";
        break;
      case 2:
        id = "ProvideDetails";
        break;
      case 3:
        id = "PhoneVerification";
        break;
      case 4:
        id = "ChangeTemporaryPassword";
        break;
      case 5:
        id = "DiabetesType";
        break;
      default:
        id = "SubmitUniqueId";
        break;
    }
    return id;
  }, [step]);

  return (
    <StepComponent
      navigation={navigate}
      currentStep={step}
      moveToNextStep={setStep}
      testIdScreen={testIdScreen}
      authCredentials={authCredentials}
      setAuthCredentials={setAuthCredentials}
      isSourceApp={isSourceApp}
    />
  );
};

export default SignUp;
